
import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import OurServices from "./OurServices";

function Services() {
  return (
    <div>
      <Header />
      <div 
        className="container-fluid py-5" 
        style={{
          marginBottom: "90px",
          background: "linear-gradient(rgba(9, 30, 62, .7), rgba(9, 30, 62, .7)), url('/img/our services (1270 x 400).jpg') center center no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "60vh"
        }}
      >
        <div className="row py-5">
          <div className="col-12 pt-lg-5 mt-lg-5 text-center">
            <h1 className="display-4 text-white animated zoomIn">Services</h1>
            <a href="/" className="h5 text-white">Home</a>
            <i className="far fa-circle text-white px-2"></i>
            <a href="/services" className="h5 text-white">Services</a>
          </div>
        </div>
      </div>
      
      <OurServices/>
      <Footer />
    </div>
  );
}

export default Services;